"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divideResearchActivities = exports.combineTools = exports.divideTools = exports.ResearchActivities = exports.DocumentationTools = void 0;
var types_1 = require("./types");
Object.defineProperty(exports, "DocumentationTools", { enumerable: true, get: function () { return types_1.DocumentationTools; } });
Object.defineProperty(exports, "ResearchActivities", { enumerable: true, get: function () { return types_1.ResearchActivities; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "divideTools", { enumerable: true, get: function () { return utils_1.divideTools; } });
Object.defineProperty(exports, "combineTools", { enumerable: true, get: function () { return utils_1.combineTools; } });
Object.defineProperty(exports, "divideResearchActivities", { enumerable: true, get: function () { return utils_1.divideResearchActivities; } });
